<template>
    <div class="fullBg  animate__animated animate__bounceIn">
        <div class="rightBox">
            <!-- <div class="headP">
                 <p class="name">{{userMsgData?userMsgData.name:''}}</p>
                 <p class="playerMsg">
                     <i>{{userMsgData?titMsg(userMsgData.title):''}}</i>
                     <span>{{teamsStr}}</span>
                 </p>
             </div>-->
            <div class="headP">
                <p class="img"><img
                    :src="userMsgData?userMsgData.avatar:require('@/assets/img/updateImg/playerHead.png')" alt="">
                </p>
                <p class="name">
                    <span class="zh">{{ userMsgData ? userMsgData.name : '' }}</span>
                    <span class="en">{{ userMsgData ? userMsgData.nameEn : '' }}</span>
                </p>
                <p class="position">
                    <img src="../assets/img/playerImg/staffPosition.svg" alt="">
                    <i>{{ userMsgData ? titMsg(userMsgData.title) : '' }}</i>
                </p>
                <p class="playerMsg" v-if="teamsStr != ''">
                    <span class="star">{{ teamsStr }}</span>
                </p>
            </div>
            <div class="basicMsg">
                <p><span class="label">身高：</span><span
                    class="val akrobatBold">{{ userBodyData && userBodyData.height ? userBodyData.height : '-' }}</span><span
                    class="unit">cm</span></p>
                <p><span class="label">体重：</span><span
                    class="val akrobatBold">{{ userBodyData && userBodyData.weight ? userBodyData.weight : '-' }}</span><span
                    class="unit">kg</span></p>
                <p><span class="label">血型：</span><span
                    class="val akrobatBold">{{ userBodyData && userBodyData.bloodType ? userBodyData.bloodType : '-' }}</span>
                </p>
                <p><span class="label">手机号：</span><span class="val akrobatBold"
                                                        style="font-size: 36px">{{ userMsgData && userMsgData.phone ? userMsgData.phone : '-' }}</span>
                </p>
            </div>
            <p class="tit">个人信息</p>
            <div class="professionalMsg">
                <ul class="header">
                    <li><span class="label">微信号码</span><span
                        class="value">{{ userMsgData && userMsgData.weixin ? userMsgData.weixin : '-' }}</span></li>
                    <li><span class="label">家庭住址</span><span
                        class="value">{{ userMsgData && userMsgData.address ? userMsgData.address : '-' }}</span></li>
                    <li><span class="label">入职时间</span><span
                        class="value">{{ userMsgData && userMsgData.startDate ? userMsgData.startDate : '-' }}</span>
                    </li>
                    <li><span class="label">原俱乐部</span><span
                        class="value">{{ userMsgData && userMsgData.address ? userMsgData.address : '-' }}</span></li>
                </ul>
                <ul>
                    <li><span class="label">出生日期</span><span
                        class="value">{{ userMsgData && userMsgData.birthday ? userMsgData.birthday : '-' }}</span></li>
                    <li><span class="label">户籍信息</span><span
                        class="value">{{ userMsgData && userMsgData.registeredResidence ? userMsgData.registeredResidence : '-' }}</span>
                    </li>
                    <li><span class="label">邮   箱</span><span
                        class="value">{{ userMsgData && userMsgData.email ? userMsgData.email : '-' }}</span></li>
                    <li><span class="label">身份证号</span><span
                        class="value">{{ userMsgData && userMsgData.identityCard ? userMsgData.identityCard : '-' }}</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "coachDetail",
    data() {
        return {
            userMsgData: null,//球员基本信息
            userBodyData: null,//球员基本信息
            allTit: [],
            teamsStr: "",//所在梯队
        }
    },
    mounted() {
        this.info();
    },
    methods: {
        info() {
            let data = {
                id: this.$route.params.id,
                // id: '5f09beab2bbde45f19a05589',
                info: 'staffPersonal'
            }
            let data2 = {
                id: this.$route.params.id,
                // id: '5f09beab2bbde45f19a05589',
                info: 'staffBody'
            }
            this.tit(data)
            this.playerMsg(data)
            this.playerBody(data2)
        },
        playerMsg(data) {
            this.$server.getUserMsg(data)
                .then((res) => {
                    this.userMsgData = res.data;
                    this.$parent.$parent.imgAi(this.$imgJson.handAiImgArr);
                    this.$parent.$parent.audioPlayFn(this.$global.audioPlayUrl("这是" + res.data.name + '的详细信息'), true, false)
                    this.getUserTeams();
                })
        },
        playerBody(data) {
            this.$server.getUserMsg(data)
                .then((res) => {
                    this.userBodyData = res.data;
                })
        },
        getUserTeams() {
            let data = {
                userId: this.$route.params.id,
                type: 'staff'
            }
            this.$server.getUserTeams(data)
                .then((res) => {
                    this.teamsStr = "";
                    if (res.data.length) {
                        if (res.data.length > 3) {
                            let arr = res.data.slice(0, 3);
                            this.teamsStr = arr.join('/');
                            this.teamsStr = this.teamsStr + '...'
                        } else {
                            this.teamsStr = res.data.join('/')
                        }
                    } else {
                        this.teamsStr = "-"
                    }
                })
        },
        tit() {
            this.$server.commonDataTit({key: 'title'})
                .then((res) => {
                    this.allTit = res.data;
                })
        },
        titMsg(str) {
            for (let i = 0; i < this.allTit.length; i++) {
                if (this.allTit[i].key == str) {
                    return this.allTit[i].value
                }
            }
        }
    }
}
</script>

<style scoped lang="less">
.fullBg {
    background-image: url("../assets/img/updateImg/bg3.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.rightBox {
    width: 75%;
    float: left;
    height: calc(100% - 8vw);
    box-sizing: border-box;
    display: inline-block;
    margin-bottom: 3vw;
    padding: 5vw 8vw 0 5vw;
    color: #fff;

    .tit {
        font-size: 36px;
        text-align: left;
        margin-bottom: 1.5vw;
        background-image: url("../assets/img/playerImg/titleBg.png");
        background-repeat: no-repeat;
        background-size: auto 100%;
        line-height: 4vw;
    }

    .headP {
        font-size: 44px;
        margin-top: 3vw;
        height: 8vw;
        /*line-height: 8vw;*/
        background-size: auto 100%;
        background-repeat: no-repeat;
        position: relative;

        .img {
            float: left;
            width: 7vw;
            height: 7vw;
            overflow: hidden;
            border-radius: 50%;
            background-color: rgba(12, 12, 13, 1);

            img {
                width: 100%;
            }
        }

        .name {
            padding-left: 3vw;
            float: left;
            font-family: PingFangMedium;

            span {
                display: block;
            }

            span.zh {
                font-weight: bolder;
                font-size: 60px;
                background: linear-gradient(180deg, #FFFFFF 0%, #CAC9C9 200%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
            }

            span.en {
                font-size: 30px;
                background: linear-gradient(180deg, rgba(255, 255, 255, .6) 0%, rgba(202, 201, 201, .6) 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
            }
        }

        .position {
            float: left;
            margin-left: 2vw;
            margin-top: 1.5vw;
            font-size: 24px;
            padding-left: .5vw;
            padding-right: .5vw;
            background: #42A5F5;
            border-left: 4px solid #276EA7;
            border-top: 4px solid #276EA7;
            border-bottom: 4px solid #276EA7;
            position: relative;
            /*box-sizing: border-box;*/

            i {
                height: 2vw;
                line-height: 2vw;
                font-style: normal;
            }

            img {
                position: absolute;
                right: -0.9vw;
                top: -4px;
                height: calc(100% + 8px);
            }
        }

        .playerMsg {
            position: absolute;
            right: -6.9vw;
            top: 3vw;
            margin-left: 2vw;
            text-align: left;
            margin-top: 1.5vw;

            .star {
                background-image: url("../assets/img/playerImg/bg1.svg");
                background-size: 100% 100%;
                padding-right: 5vw;
                padding-left: 1vw;
                height: 2.5vw;
                line-height: 2.5vw;
                width: 16vw;
                display: inline-block;
                font-size: 26px;
                font-family: PingFangMedium;
                color: rgba(255, 255, 255, .8);
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
            }

        }
    }

    .basicMsg {
        font-size: 22px;
        margin-top: 2.5vw;
        padding-bottom: 1vw;
        text-align: left;
        width: 110%;

        p {
            height: 2.5vw;
            line-height: 2.5vw;
            display: inline-block;
            width: calc(33.3% - 4vw);
            background-image: url("../assets/img/updateImg/personalLittle.png");
            background-size: 100% 100%;
            background-repeat: no-repeat;
            background-position: left;
            padding-left: 2vw;
            box-sizing: border-box;
            margin-bottom: 1vw;
            margin-right: 4vw;

            .unit {
                color: rgba(255, 255, 255, .6);
                font-size: 30px;
                font-family: PingFang;
                margin-left: .5vw;
            }

            span {
                float: left;
            }

            &:first-child, &:nth-child(2), &:nth-child(3) {
                font-size: 34px;
            }

            .label {
                font-size: 24px;
                color: rgba(255, 255, 255, .6);
                padding-right: .5vw;
            }

            .val {
                padding-left: 2vw;
            }
        }
    }

    .professionalMsg {
        text-align: left;

        ul {
            width: 50%;
            float: left;
            font-size: 26px;
            font-family: PingFangMedium;
            font-weight: normal;

            li {
                line-height: 3vw;
                padding-right: 2vw;
                box-sizing: border-box;
            }

            .label {
                display: inline-block;
                width: 23%;
                padding-right: 1vw;
                box-sizing: border-box;
                color: rgba(234, 240, 247, .6);
            }

            .value {
                color: rgba(255, 255, 255, .8);
            }
        }
    }
}
</style>
